import clsx from "clsx";
import { useTooltip } from "hooks/useTooltip";
import { ReactNode } from "react";

export const TabButton = (props: {
    isSelected: boolean;
    onClick?: () => void;
    text: ReactNode;
    size?: "md" | "sm";
    disabled?: boolean;
    dropdown?: boolean;
    isInsideCard?: boolean;
    title?: string;
    tooltip?: string;
}) => {
    const { text, isSelected, onClick, size = "md", dropdown, disabled, isInsideCard, title, tooltip } = props;

    const { tooltipRef } = useTooltip({ title: tooltip, placement: "top" });

    return (
        <button
            ref={tooltipRef}
            type="button"
            onClick={onClick}
            title={title}
            disabled={disabled}
            data-bs-toggle={dropdown && "dropdown"}
            data-bs-auto-close={dropdown && "true"}
            className={clsx(
                "btn icon-link rounded-pill",
                isSelected
                    ? isInsideCard
                        ? "btn-dark"
                        : "btn-white"
                    : isInsideCard
                    ? "btn-outline-dark"
                    : "btn-outline-white",
                size === "sm" && "btn-sm",
                dropdown && "dropdown-toggle",
            )}
        >
            {text}
        </button>
    );
};
